<template>
    <section class="who-is-this-for">

        <h2>Who is this for?</h2>

        <ul>

            <li class="wow fadeInUp">

                <p>
                    <img src="@/assets/images/icons/peoples.svg" alt="Peoples icon">
                </p>

                <small>
                    Private investors and traders
                </small>

            </li>

            <li class="wow fadeInUp" data-wow-delay="0.1s">

                <p>
                    <img src="@/assets/images/icons/algorithm.svg" alt="Algorithm icon">
                </p>

                <small>
                    Algorithmic traders
                </small>

            </li>

            <li class="wow fadeInUp" data-wow-delay="0.2s">

                <p>
                    <img src="@/assets/images/icons/graph.svg" alt="Graph icon">
                </p>

                <small>
                    Funds and portfolio managers
                </small>

            </li>

            <li class="wow fadeInUp" data-wow-delay="0.3s">

                <p>
                    <img src="@/assets/images/icons/bank.svg" alt="Bank icon">
                </p>

                <small>
                    Institutional investors
                </small>

            </li>

            <li class="wow fadeInUp" data-wow-delay="0.4s">

                <p>
                    <img src="@/assets/images/icons/safe.svg" alt="Safe icon">
                </p>

                <small>
                    Banks and insurance companies
                </small>

            </li>

        </ul>

    </section>
</template>

<script>
    export default {
        name: "WhoIsThisFor"
    }
</script>